/* Mesa theme — theme.js (no dependencies) */
(function () {
  'use strict';
  var R = (window.theme && window.theme.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' };
  var S = (window.theme && window.theme.strings) || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header scroll state ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Generic drawer helpers ---------- */
  var lastFocus = null;
  function openPanel(el) {
    if (!el) return; lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closePanel(el) {
    if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.drawer.is-open, .mobile-nav.is-open').forEach(closePanel); }
  });

  /* ---------- Mobile nav ---------- */
  var mnav = $('[data-mobile-nav]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-open]')) { openPanel(mnav); }
    if (e.target.closest('[data-mobile-close]')) { closePanel(mnav); }
  });

  /* ---------- Cart ---------- */
  function drawer() { return $('[data-cart-drawer]'); }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; el.setAttribute('data-count', n); });
  }
  function refreshDrawer(open) {
    return fetch(R.cart + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var current = drawer();
        if (fresh && current) {
          current.querySelector('.drawer__panel').innerHTML = fresh.querySelector('.drawer__panel').innerHTML;
        }
        return fetch(R.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCount(cart.item_count); if (open) openPanel(drawer()); return cart; });
  }
  function getCart() { return fetch(R.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function addVariant(id, plan, props) {
    return getCart().then(function (cart) {
      var exists = cart.items.some(function (i) { return String(i.variant_id) === String(id) && String(i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : '') === String(plan || ''); });
      if (exists) return cart; // digital products: one copy is enough
      var item = { id: Number(id), quantity: 1 };
      if (plan) item.selling_plan = Number(plan);
      if (props) item.properties = props;
      return fetch(R.cartAdd + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
    });
  }
  function planOf(form) { var p = form.querySelector('[data-selling-plan]'); return p && p.value ? p.value : null; }
  function subConsentOk(form) {
    var plan = planOf(form); var c = form.querySelector('[data-sub-consent]');
    if (!plan || !c) return true;
    if (c.checked) return true;
    var box = c.closest('[data-consent]'); if (box) { box.classList.add('is-invalid'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    c.focus(); return false;
  }
  function propsOf(form) {
    var plan = planOf(form); if (!plan) return null;
    return { '_Recurring payment consent': 'Accepted ' + new Date().toISOString() };
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    if (!subConsentOk(form)) return;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = S.adding || 'Adding…'; }
    addVariant(idInput.value, planOf(form), propsOf(form))
      .then(function () { return refreshDrawer(true); })
      .catch(function (err) { alertInline(form, (err && (err.description || err.message)) || 'Something went wrong'); })
      .then(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; } });
  });

  function alertInline(form, msg) {
    var n = form.querySelector('.notice--error');
    if (!n) { n = document.createElement('p'); n.className = 'notice notice--error'; form.appendChild(n); }
    n.textContent = msg;
  }

  // Buy now: add then go straight to the cart page (where the acknowledgement is collected)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]');
    if (b) {
      var form = b.closest('form'); var id = form && form.querySelector('[name="id"]');
      if (!id) return;
      b.setAttribute('aria-disabled', 'true');
      if (!subConsentOk(form)) return;
      addVariant(id.value, planOf(form), propsOf(form)).then(function () { window.location.href = R.cart; })
        .catch(function () { b.removeAttribute('aria-disabled'); });
    }
    var q = e.target.closest('[data-quick-add]');
    if (q) { q.setAttribute('aria-disabled', 'true'); addVariant(q.getAttribute('data-quick-add')).then(function () { return refreshDrawer(true); }).catch(function () { q.removeAttribute('aria-disabled'); }); }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      rm.textContent = '…';
      fetch(R.cartChange + '.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-line-remove'), quantity: 0 })
      }).then(function () { return refreshDrawer(true); });
    }
    var opener = e.target.closest('[data-cart-open]');
    if (opener && drawer()) { e.preventDefault(); openPanel(drawer()); }
    if (e.target.closest('[data-cart-close]')) { closePanel(drawer()); }
  });

  /* ---------- Digital delivery acknowledgement ---------- */
  document.addEventListener('change', function (e) {
    var sc = e.target.closest('[data-sub-consent]');
    if (sc) { var b = sc.closest('[data-consent]'); if (b) b.classList.remove('is-invalid'); }
    var pr = e.target.closest('[data-plan-radio]');
    if (pr) {
      var form = pr.closest('form'); var hidden = form.querySelector('[data-selling-plan]'); hidden.value = pr.value;
      var terms = form.querySelector('[data-sub-terms]'); if (terms) terms.hidden = !pr.value;
    }
    var c = e.target.closest('[data-consent-input]');
    if (!c) return;
    var box = c.closest('[data-consent]'); if (box) box.classList.remove('is-invalid');
    var name = c.getAttribute('data-attr') || 'Digital delivery acknowledgement';
    var attrs = {}; attrs[name] = c.checked ? 'Accepted' : ''; attrs[name + ' at (UTC)'] = c.checked ? new Date().toISOString() : '';
    fetch(R.cartUpdate + '.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  });
  document.addEventListener('click', function (e) {
    var chk = e.target.closest('[name="checkout"]');
    if (!chk) return;
    var formId = chk.getAttribute('form');
    var scope = formId ? document : chk.closest('form') || document;
    var inputs = formId ? $$('[data-consent-input][form="' + formId + '"]') : $$('[data-consent-input]', scope);
    var missing = inputs.filter(function (i) { return !i.checked; });
    if (missing.length) {
      e.preventDefault();
      missing.forEach(function (i) { var b = i.closest('[data-consent]'); if (b) b.classList.add('is-invalid'); });
      var first = missing[0].closest('[data-consent]'); if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      missing[0].focus();
    }
  }, true);

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var i = t.getAttribute('data-thumb');
    var wrap = t.closest('[data-product]');
    $$('[data-media-slide]', wrap).forEach(function (s) { s.hidden = s.getAttribute('data-media-slide') !== i; });
    $$('[data-thumb]', wrap).forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
  });
  var vs = $('[data-variant-select]');
  if (vs) vs.addEventListener('change', function () { var f = vs.closest('form'); f.querySelector('[name="id"]').value = vs.value; });

  /* ---------- Sticky add to cart ---------- */
  var sticky = $('[data-sticky-atc]'); var atc = $('[data-atc]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(atc);
  }

  /* ---------- Collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); window.location.href = u.toString(); });

  /* ---------- Recommendations ---------- */
  var rec = $('[data-recommendations]');
  if (rec && !rec.querySelector('.product-grid')) {
    fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html'); var n = d.querySelector('[data-recommendations]');
      if (n && n.innerHTML.trim()) { rec.innerHTML = n.innerHTML; observeReveals(rec); } else { rec.remove(); }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function observeReveals(root) {
    var els = $$('.reveal:not(.is-in)', root);
    if (!document.body.classList.contains('has-animations') || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en, idx) {
        if (en.isIntersecting) { var el = en.target; setTimeout(function () { el.classList.add('is-in'); }, (idx % 4) * 80); io.unobserve(el); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  observeReveals(document);

  /* ---------- Cookie preferences (Shopify privacy banner) ---------- */
  var cp = $('[data-cookie-prefs]');
  if (cp) {
    var showIfAvailable = function () { if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') cp.hidden = false; };
    showIfAvailable(); setTimeout(showIfAvailable, 1500);
    cp.addEventListener('click', function () { if (window.privacyBanner) window.privacyBanner.showPreferences(); });
  }

  /* ---------- Withdrawal function (EU/UK) ---------- */
  var ws = $('[data-withdraw-start]');
  if (ws) ws.addEventListener('click', function () {
    var f = $('[data-withdraw-form]'); f.hidden = false; ws.hidden = true;
    var first = f.querySelector('input'); if (first) first.focus();
  });
  var wf = $('[data-withdraw-form] form') || $('form[data-withdraw]');
  if (wf) wf.addEventListener('submit', function () {
    var t = wf.querySelector('[name="contact[Received at (UTC)]"]'); if (t) t.value = new Date().toISOString();
  });
  document.addEventListener('shopify:section:load', function (e) { observeReveals(e.target); });
})();
